import styled from "styled-components";

export const EditNoteIcon = styled.div`
  cursor: pointer;

  svg {
    opacity: 0.5;
  }
`;
